import { TravelerPaxResponse } from '@pax/entities/traveler-pax';

export function travelerReduxMapper(response: TravelerPaxResponse[]): TravelerPaxResponse[] {
  return response.map(traveler => {
    const travelerVm = { ...traveler };
    const loyaltyTraveler = travelerVm.loyalty.map(loyalty => ({
      ...loyalty,
      traveler: travelerVm._id
    }));
    return {
      ...travelerVm,
      loyalty: [...loyaltyTraveler]
    };
  });
}

export function travelerMapperWithDeleteDocument(entity: TravelerPaxResponse, documentId: string): TravelerPaxResponse {
  const documentIndex = entity?.documents.findIndex(item => item._id === documentId);
  if (documentIndex < 0) return entity;
  else {
    const documents = [
      ...entity.documents.slice(0, documentIndex),
      ...entity.documents.slice(documentIndex + 1)
    ];
    return {
      ...entity,
      documents: [...documents]
    };
  }
}
